import type { AccountDetailsResponseDto, LegalEntityEnum } from '@onrunning/backstage-models';
import { defineStore } from 'pinia';

import { AccountsReceivablesEmails } from '@/constants/accounts-receivables.constants';

interface State {
  account: AccountDetailsResponseDto | undefined;
  loading: boolean;
  error: string | null;
}

export const useAccountStore = defineStore('account', {
  state: (): State => ({
    account: undefined,
    loading: false,
    error: null,
  }),

  getters: {
    isOnHold(state): boolean {
      return state.account?.onHold ?? false;
    },
    accountReceivablesEmail(state): string | undefined {
      if (!state.account?.legalEntity) {
        return undefined;
      }

      return AccountsReceivablesEmails[state.account.legalEntity as keyof typeof AccountsReceivablesEmails];
    },
    legalEntity(state): LegalEntityEnum | undefined {
      return state.account?.legalEntity;
    },
  },

  actions: {
    setAccountDetails(details: AccountDetailsResponseDto | undefined) {
      this.account = details;
      this.error = null;
    },

    setLoading(isLoading: boolean) {
      this.loading = isLoading;
    },

    setError(errorMessage: string | null) {
      this.error = errorMessage;
    },

    reset() {
      this.account = undefined;
      this.loading = false;
      this.error = null;
    },
  },
});
